export default "__VITE_ASSET__CfBolwuZ__"